import React from "react";
import { createRoot } from "react-dom/client";
import DashApp from "./dashApp";
import { unregister } from "./registerServiceWorker";
import "antd/dist/reset.css";
import "./customStyle.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <DashApp />
  </React.StrictMode>
);

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./dashApp.js", () => {
    const NextApp = require("./dashApp").default;
    root.render(
      <React.StrictMode>
        <NextApp />
      </React.StrictMode>
    );
  });
}
unregister();
